export interface IAssetDetailTbl {
	assetId: number;
	assetTypeId?: number;
	tankAssetNumber?: string;
	assetType?: string;
	domicile?: string;
	domicileId?: number;
	status?: any;
	statusStr?: string;
	imageFileName?: string;
	thumbnailFileName?: string;
	companyOwned?: string;
	billableRatePerHour?: number;
	file?: any;
	dateOfExpectedRepair?: Date;
	subContracted: boolean;
	loadBearing: boolean;
	powerTakeOff: boolean;
	notes?: string;
	siteLocation?: any;
	siteId?: number;
	assignedSiteLocation?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;
};

export class AssetDetailTbl implements IAssetDetailTbl {
	assetId = 0;
	assetTypeId = 0;
	tankAssetNumber = '';
	assetType = '';
	domicile = '';
	domicileId = 0;
	status = '';
	statusStr = '';
	imageFileName = '';
	thumbnailFileName = '';
	companyOwned = '';
	billableRatePerHour = 0;
	file = '';
	dateOfExpectedRepair = new Date();
	subContracted = false;
	loadBearing = false;
	powerTakeOff = false;
	notes = '';
	siteLocation = '';
	siteId = 0;
	assignedSiteLocation = '';
	isUpdatedOffline = false;
	canDelete = false;
};
